<template>
  <!-- <can I="view" a="activities"> -->
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-card>
          <div slot="header" class="d-flex justify-content-between">
            {{ $dt('audit_logs.audit_logs_list_title') }}
            <div v-if="listPaginator.last_page > 1" >
                <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" size="small" class="mb-0"/>
            </div>
          </div>
          <div v-if="loading" class="text-center">
            <b-spinner type="grow" variant="primary"/>
          </div>
          <div v-else>
            <b-row>
              <b-col cols="12">
                <b-table class="table-sm text-center" responsive outlined hover head-variant="light"
                         :fields="tableFields" :items="tableItems"
                         @row-clicked="rowClicked"
                         >

                  <template v-slot:cell(causer)="{ value }">
                    {{ value.full_name }} <b-badge>{{ value.email }}</b-badge>
                  </template>
                  <template v-slot:cell(created_at)="{ value }">{{ momentf(value) }}</template>
                  <template v-slot:cell(label_set_id)="{ item, value }">
                    <b-link v-if="value" :to="{ name: 'LabelSetSamples', params: { project_id: activeProjectId, label_set_id: item.label_set_id } }" >{{ value }}</b-link>
                  </template>
                  <template v-slot:cell(sample_id)="{ item, value }">
                    <b-link v-if="item.label_set_id && item.sample_id"
                      :to="{ name: 'LabelSample', params: { project_id: activeProjectId, sample_id: item.sample_id, label_set_id: item.label_set_id } }" >
                      {{ value }}
                    </b-link>
                    <span v-else-if="item.sample_id">{{ value }}</span>
                  </template>
                  <!-- <template #row-details="row">
                    <b-card>
                      <vue-json-pretty :data="row.item.properties" />
                      <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
                    </b-card>
                  </template> -->
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <!--Paginator-->
              <b-col cols="12" v-if="tableItems.length">
                <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange" size="small"/>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
    </div>
  <!-- </can> -->
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import VueJsonPretty from 'vue-json-pretty';
import VT from '@/store/types';
import statuses from '@/store/statuses';
import 'vue-json-pretty/lib/styles.css';
import Services from '@/services/index';

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      loading: true,
      tableFields: [
        { key: 'id', label: this.$t('global.id') },
        { key: 'log_name', label: this.$dt('audit_logs.log_name', 'Log Name') },
        { key: 'description', label: this.$t('global.description') },
        { key: 'label_set_id', label: this.$dt('audit_logs.label_set', 'Label Set') },
        { key: 'sample_id', label: this.$dt('audit_logs.label_set', 'Sample') },
        { key: 'causer', label: this.$dt('audit_logs.causer', 'User') },
        { key: 'created_at', label: this.$dt('audit_logs.created_at', 'When') },
      ],
      list: {},
      filters: {
        sort_field: 'id',
        sort_order: true,
        // search: '',
        per_page: 20,
      },
    };
  },
  props: {
    page: {},
    embedded: {
      type: Boolean,
      default: false,
    },
    user_id: {
      type: Number,
      default: null,
    },
  },
  components: {
    VueJsonPretty,
    Pagination,
  },
  computed: {
    ...mapState('Auth', ['activeProjectId']),
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    tableItems() {
      return this.list.data || [];
    },
    params() {
      return {
        ...this.filters,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc',
        ...(this.user_id ? {
          causer_type: 'App\\Models\\User',
          causer_id: this.user_id,
        } : {})
      };
    },
  },
  watch: {
    page: 'getData',
    filters: { deep: true, handler: 'getData' },
  },
  methods: {
    getData() {
      this.loading = true;
      Services.auditLogs.list({ projectId: this.activeProjectId, params: this.params }).then(({ data }) => {
        this.list = data;
        this.loading = false;
      }).catch((err) => {
        if (err.code !== 'ERR_CANCELED') {
          this.loading = false;
          console.log(err);
        }
      });
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page && !this.embedded) {
        this.$router.push({ name: 'AuditLogs', params: { page } });
      } else {
        this.page = page;
      }
    },
    rowClicked(item, index, event) {

    },
  }
};

</script>

<style scoped lang=scss></style>
